var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train-item__icon"},[_c('i',{staticClass:"add-button__icon material-icons",on:{"click":_vm.add}},[_vm._v(" add ")])])}
var staticRenderFns = []

export { render, staticRenderFns }